<template>
    <MainHeader app="sales" />

    <div class="modal-holder sales-modal" v-if="showProductsModal">
        <div class="modal-card">
            <div class="modal-card-header">
                <h3>Produktlista</h3>
            </div>
            <div class="modal-content scroll-bar">
                <div class="sales-company-codes-header">
                    <h5>Resultat</h5>
                </div>

                <div class="sales-company-codes">
                    <div
                        class="sales-company-code"
                        v-for="clipcard in clipcards"
                    >
                        <span>
                            {{ clipcard.name }}
                        </span>
                        <span>
                            <button
                                v-if="productExistInCategory(korv, clipcard)"
                                class="button button-disabled"
                            >
                                Lägg till
                            </button>

                            <button
                                v-if="!productExistInCategory(korv, clipcard)"
                                @click="addProduct(clipcard)"
                                class="button"
                            >
                                Lägg till
                            </button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <button @click="showProductsModal = false" class="button">
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="settings-header-top">
        <div>
            <h1>Inställningar</h1>
        </div>
    </div>

    <div class="board-tabs-holder settings-tabs have-top-header">
        <ul class="board-tabs">
            <li
                @click="changeTab('knowledge-bank')"
                :class="currentTab == 'knowledge-bank' ? 'current' : ''"
            >
                Kunskapsbanken
            </li>
            <li
                @click="changeTab('dispatch')"
                :class="currentTab == 'dispatch' ? 'current' : ''"
            >
                Utskick
            </li>
            <li
                @click="changeTab('recommended')"
                :class="currentTab == 'recommended' ? 'current' : ''"
            >
                Rekommenderat
            </li>
            <li
                @click="changeTab('campaigns')"
                :class="currentTab == 'campaigns' ? 'current' : ''"
            >
                Kampanj
            </li>
            <li
                @click="changeTab('product-info')"
                :class="currentTab == 'product-info' ? 'current' : ''"
            >
                Produktinfo
            </li>
            <li
                @click="changeTab('translations')"
                :class="currentTab == 'translations' ? 'current' : ''"
            >
                Översättningar
            </li>
        </ul>
    </div>

    <main class="settings-holders have-top-header">
        <!-- Kunskapsbanken -->
        <div class="setting-tab" v-show="currentTab === 'knowledge-bank'">
            <div class="holder-settings holder-settings-small">
                <div class="w-full">
                    <draggable
                        v-model="knowledgeBank"
                        item-key="id"
                        handle=".handle"
                    >
                        <template #item="{ element, index }">
                    <div>
                            <div
                                class="list-item"
                                :class="element?.open ? 'list-item-open' : ''"
                            >
                                <div class="list-item-header">

                                    <div class="handle board-info-button">
                                            <img
                                                src="/assets/icon-dehaze.svg"
                                                alt="move"
                                                />
                                        </div>
                                    <input
                                        class="input-setting"
                                        type="text"
                                        v-model="element.name"
                                    />
                                    <div class="list-item-header-actions">
                                        <i
                                            :class="
                                                element?.open
                                                    ? 'board-settings-open'
                                                    : ''
                                            "
                                            class="material-icons color-blue pointer board-info-button board-settings"
                                            @click="
                                                element.open = !element.open
                                            "
                                            >arrow_drop_down</i
                                        >
                                        <i
                                            class="material-icons pointer board-delete-button"
                                            @click="
                                            knowledgeBank.splice(
                                                                        index,
                                                                        1
                                                                    )"
                                            >remove</i
                                        >
                                    </div>
                                </div>
                                <div
                                    class="list-item-content"
                                    v-show="element?.open"
                                >
                                    <div class="QuillEditorHolder text-content">
                                        <QuillEditor
                                            contentType="html"
                                            v-model:content="element.info"
                                            theme="snow"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="actions-holder">
                                        <label class="label-checkbox">
                                            <input
                                                type="checkbox"
                                                :value="true"
                                                v-model="element.showOnLastStep"
                                            />
                                            <div class="checkbox"></div>
                                            Visa frågan på sista sidan
                                        </label>
                                    </div>
                                </div>
                        </template>
                    </draggable>



                    <div class="settings-line"></div>

                    <div class="clipcard-settings-buttons">
                        <div>
                            <button
                                class="button button-small"
                                @click="
                                knowledgeBank.push({
                                    open: false,
                                    name: '',
                                    info: '',
                                    showOnLastStep: false,
                                })
                            "
                            >
                                Ny post
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Utskick -->
        <div class="setting-tab" v-show="currentTab === 'dispatch'">
            <div class="holder-settings holder-settings-small">
                <div class="settings-label">SMS text</div>
                <textarea class="textarea" v-model="sms.default"></textarea>
                <div class="letter-count">
                    Antal tecken: {{ sms.default.length }}
                </div>

                <div class="settings-label">Giltighetstid, antal dagar</div>
                <select class="select-small" v-model="sms.valid">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                </select>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                <div class="settings-label">Påminnelse SMS text</div>
                <textarea class="textarea" v-model="sms.reminder"></textarea>
                <div class="letter-count">
                    Antal tecken: {{ sms.reminder.length }}
                </div>

                <div class="settings-label">Påminnelse, antal dagar efter första sms</div>
                <select class="select-small" v-model="sms.daysBetweenRemider">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                </select>
            </div>
        </div>

        <!-- Rekommenderat -->
        <div class="setting-tab" v-show="currentTab === 'recommended'">
            <div class="holder-settings holder-settings-small">
                <div v-for="zip in centers" class="recommended-zip-holder">
                    <h3>{{ zip.name }}</h3>
                    <div v-for="center in zip.centers" class="recommended-line">
                        <input
                        readonly
                        type="text"
                        :value="center.name"            
                        />
                        <select v-model="recommended[center.id]">
                            <option :value="undefined">Välj rekommenderat</option>
                            <option
                                v-for="subscription in subscriptions"
                                :value="subscription"
                            >
                                {{ subscription }}
                            </option>
                        </select>

                        <div class="board-add-button pointer" v-if="!recommendedHaveNote(center.id)" @click="recommendedTexts[center.id] = { text: '' }; ">
                            <i
                                class="color-blue"
                                ><img
                            src="/assets/icon-add_notes-outlined.svg"
                            alt="add-notes-icon"
                        /></i
                            >
                        </div>
                        <div class="board-add-button pointer" v-if="recommendedHaveNote(center.id)" @click="delete recommendedTexts[center.id]">
                            <i
                                class="color-blue"
                                ><img
                            src="/assets/icon-add_notes.svg"
                            alt="add-notes-icon"
                        /></i
                            >
                        </div>


                        <div class="QuillEditorHolder text-content" v-if="recommendedHaveNote(center.id)">
                            <QuillEditor
                                contentType="html"
                                v-model:content="recommendedTexts[center.id].text"
                                theme="snow"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Produktinfo -->
        <div class="setting-tab" v-show="currentTab === 'product-info'">
            <div class="holder-settings holder-settings-small">
                <div class="w-full">
                    <div class="category" v-for="category in defaultCategories">
                        <div class="category-header category-header-no-handle">
                            <h3>
                                <input
                                    type="text"
                                    class="input-header"
                                    v-model="category.name"
                                />
                            </h3>
                            <div class="input-header-buttons">
                                <i
                                    :class="
                                        category?.open
                                            ? 'board-settings-open'
                                            : ''
                                    "
                                    class="board-settings material-icons pointer"
                                    @click="category.open = !category?.open"
                                    >arrow_drop_down</i
                                >
                            </div>
                        </div>

                        <div class="list-item-content" v-show="category?.open">
                            <div class="QuillEditorHolder text-content">
                                <QuillEditor
                                    contentType="html"
                                    v-model:content="category.info"
                                    theme="snow"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="settings-line"></div>

                    <draggable
                        v-model="productCategories"
                        item-key="id"
                        handle=".handle"
                    >
                        <template #item="{ element: mainElement, asd }">
                            <div class="category">
                                <div class="category-header">
                                        <div class="pointer handle"><img
                                                src="/assets/icon-dehaze-white.svg"
                                                alt="move"
                                                /></div>
                                    <h3>
                                        <input
                                            type="text"
                                            class="input-header"
                                            v-model="mainElement.name"
                                        />
                                    </h3>
                                    <div class="input-header-buttons">
                                        
                                        <i
                                            :class="
                                                mainElement?.open
                                                    ? 'board-settings-open'
                                                    : ''
                                            "
                                            class="board-settings material-icons pointer"
                                            @click="
                                                mainElement.open =
                                                    !mainElement?.open
                                            "
                                            >arrow_drop_down</i
                                        >

                                        <i
                                            class="material-icons pointer board-delete-button"
                                            @click="
                                                productCategories.splice(asd, 1)
                                            "
                                            >remove</i
                                        >


                                    </div>
                                </div>
                                <div
                                    class="list-group"
                                    v-show="mainElement?.open"
                                >
                                    <div class="w-full">
                                        <draggable
                                            v-model="mainElement.products"
                                            item-key="id"
                                            handle=".handle-product"
                                        >
                                            <template
                                                #item="{ element, index }"
                                            >
                                                <div
                                                    class="list-item"
                                                    :class="
                                                        element?.open
                                                            ? 'list-item-open'
                                                            : ''
                                                    "
                                                >
                                                    <div
                                                        class="list-item-header"
                                                    >

                                                    <div
                                                                class="handle-product"
                                                            >
                                                                <div
                                                                    class="pointer board-info-button"
                                                                    >
                                                                    <img
                                                src="/assets/icon-dehaze.svg"
                                                alt="moce"
                                                />
                                                </div>
                                                            </div>

                                                        <input
                                                            class="input-setting"
                                                            type="text"
                                                            v-model="
                                                                element.name
                                                            "
                                                        />
                                                        <div
                                                            class="list-item-header-actions"
                                                        >
                                                            <i
                                                                :class="
                                                                    element?.open
                                                                        ? 'board-settings-open'
                                                                        : ''
                                                                "
                                                                class="material-icons color-blue pointer board-info-button board-settings"
                                                                @click="
                                                                    element.open =
                                                                        !element.open
                                                                "
                                                                >arrow_drop_down</i
                                                            >
                                                            <i
                                                                class="material-icons pointer board-info-button board-delete-button"
                                                                @click="
                                                                    mainElement.products.splice(
                                                                        index,
                                                                        1
                                                                    )
                                                                "
                                                                >remove</i
                                                            >
                                                        </div>
                                                    </div>
                                                    
                                                    <div
                                                        class="list-item-content"
                                                        v-show="element?.open"
                                                    >
                                                        <div
                                                            class="QuillEditorHolder text-content"
                                                        >
                                                            <QuillEditor
                                                                contentType="html"
                                                                v-model:content="
                                                                    element.info
                                                                "
                                                                theme="snow"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </draggable>
                                        <div
                                            class="buttons button-holder-right"
                                            style="margin-top: 10px"
                                        >
                                            <i
                                            class="material-icons pointer board-add-button"
                                            @click="
                                                    showAddProductModal(
                                                        mainElement
                                                    )
                                                "
                                            >add</i
                                        >

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>

                    <div class="settings-line"></div>

                    <div class="clipcard-settings-buttons">
                        <div>
                            <button
                                class="button button-small"
                                @click="syncClipcards()"
                            >
                                Synka produkter
                            </button>
                            <span v-if="clipcardLastSync"
                                >Senaste synkning: {{ clipcardLastSync }}</span
                            >
                        </div>
                        <div>
                            <button
                                class="button button-small"
                                @click="
                                    productCategories.push({
                                        name: 'Namn',
                                        open: false,
                                        products: [],
                                    })
                                "
                            >
                                Ny kategori
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Kampanjer -->
        <div class="setting-tab" v-show="currentTab === 'campaigns'">
            <div class="holder-settings holder-settings-small">
                <div class="w-full">
                    <draggable
                        v-model="campaigns"
                        item-key="id"
                        handle=".handle"
                    >
                        <template #item="{ element, index }">
                            <div
                                class="list-item"
                                :class="element?.open ? 'list-item-open' : ''"
                            >
                                <div class="list-item-header">

                                    <div class="handle">
                                            <div
                                                class="pointer board-info-button"
                                                >
                                                <img
                                                src="/assets/icon-dehaze.svg"
                                                alt="move"
                                                />
                                                </div>
                                        </div>

                                    <input
                                        class="input-setting"
                                        type="text"
                                        v-model="element.name"
                                    />
                                    <div class="list-item-header-actions">

                                        <i
                                            :class="
                                                element?.open
                                                    ? 'board-settings-open'
                                                    : ''
                                            "
                                            class="material-icons color-blue pointer board-info-button board-settings"
                                            @click="
                                                element.open = !element.open
                                            "
                                            >arrow_drop_down</i
                                        >

                                        <i
                                            class="material-icons pointer board-delete-button"
                                            @click="campaigns.splice(index, 1)"
                                            >remove</i
                                        >

                                    </div>
                                </div>
                                <div
                                    class="list-item-content with-padding"
                                    v-show="element?.open"
                                >
                                    <div class="QuillEditorHolder text-content">
                                        <QuillEditor
                                            contentType="html"
                                            v-model:content="element.info"
                                            theme="snow"
                                        />
                                    </div>
                                    <div class="input-holder">
                                        <div class="settings-label">Kampanjkod</div>
                                        <input
                                            class="settings-input"
                                            type="text"
                                            v-model="element.code"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                    <div
                        class="buttons button-holder-right"
                        style="margin-top: 10px"
                    >
                        <button
                            class="button button-small"
                            @click="
                                campaigns.push({
                                    open: true,
                                    name: 'Kampanjnamn',
                                    info: '',
                                    code: '',
                                })
                            "
                        >
                            Ny kampanj
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Translations -->
        <div class="setting-tab" v-show="currentTab === 'translations'">
            <div class="holder-settings">
                <h2>Översättningar</h2>
                <p>Översättningar för olika delar av systemet</p>
                <select v-model="currentTranslation">
                    <option value="false">Välj språk</option>
                    <option value="no">Norska</option>
                </select>
                <div v-show="currentTranslation !== 'false'" class="w-full">
                    <h2>{{ translations[currentTranslation]?.name }}</h2>

                    <h2>Informationstext vid inloggning</h2>
                    <div class="translation-item">
                        <div
                            class="translation-orignal-text text-content"
                            v-html="loginInformation"
                        ></div>
                        <div class="translation-translated-text">
                            <div class="translation-editor-holder text-content">
                                <QuillEditor
                                    content-type="html"
                                    @blur="
                                        (editor) => {
                                            updateTranslationTextarea(
                                                'login_informationtext',
                                                editor
                                            );
                                        }
                                    "
                                    :content="
                                        getTranslationTextarea(
                                            'login_informationtext'
                                        )
                                    "
                                    theme="snow"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <button class="settings-save button button-small" @click="save()">
        Spara
    </button>

    <div v-if="loading" class="loading loading-with-text">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div>
            {{ loadingText }}
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from "axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { v4 as uuid } from "uuid";
import { mapStores } from "pinia";
import MainHeader from "../MainHeader.vue";
import { useAuthStore } from "../../stores/auth.js";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
    computed: {
        ...mapStores(useAuthStore),
    },
    components: {
        draggable,
        QuillEditor,
    },
    data() {
        return {
            recommended: {},
            recommendedTexts: {},
            subscriptions: [],
            center: [],
            clipcardLastSync: false,
            loadingText: "Laddar inställningar...",
            knowledgeBank: [],
            campaigns: [],
            productCategories: [],
            sms: {
                valid: 3,
                daysBetweenRemider: 3,
                default: "",
                reminder: "",
            },
            loginInformation: "",
            centers: [],
            loading: true,
            currentTab: "knowledge-bank",
            currentTranslation: "false",
            translations: {
                no: {
                    name: "Norska",
                    translations: {},
                },
            },
            showProductsModal: false,
            clipcards: [],
            defaultCategories: [
                {
                    key: "local",
                    open: false,
                    name: "Single site",
                    defaultName: "Single site",
                    info: "",
                },
                {
                    key: "region",
                    open: false,
                    name: "Regionen",
                    defaultName: "Regionen",
                    addGymText: true,
                    info: "",
                },
                {
                    key: "max",
                    open: false,
                    name: "Norden",
                    defaultName: "Norden",
                    addGymText: true,
                    info: "",
                },
                {
                    key: "crossfit",
                    open: false,
                    name: "Crossfit",
                    defaultName: "Crossfit",
                    addGymText: false,
                    info: "",
                },
            ],
        };
    },
    mounted() {
        let self = this;
        axios
            .post(
                self.authStore.api + "/sales/settings/get",
                {
                    key: "SalesSettings",
                },
                {
                    headers: {
                        Authorization: "Bearer " + self.authStore.token,
                    },
                }
            )
            .then((response) => {
                console.log(response.data);

                if (response.data.settings !== false) {
                    self.sms = response.data.settings.sms;
                    self.knowledgeBank = response.data.settings.knowledgeBank;
                    self.clipcards = response.data.clipcards;
                    self.clipcardLastSync = response.data.clipcards_last_sync;

                    self.centers = response.data.centers;
                    self.subscriptions = response.data.subscriptions;

                    if (response.data.settings.campaigns !== undefined) {
                        self.campaigns = response.data.settings.campaigns;
                    }

                    if (response.data.settings.recommended !== undefined) {
                        self.recommended = response.data.settings.recommended;
                    }

                    if (response.data.settings.recommendedTexts !== undefined) {
                        self.recommendedTexts = response.data.settings.recommendedTexts;
                    }

                    if (
                        response.data.settings.productCategories !== undefined
                    ) {
                        self.productCategories =
                            response.data.settings.productCategories;
                    }
                }
                self.loading = false;
            })
            .catch((error) => {
                this.loading = false;
                console.log(error);
            });
    },
    methods: {
        recommendedHaveNote(id) {
            return this.recommendedTexts[id] !== undefined;
        },
        productExistInCategory(category, product) {
            return category.products.find(function (element) {
                console.log(element.name);
                console.log(product.name);

                return element.clipcard === product.name;
            });
        },
        showAddProductModal(element) {
            this.showProductsModal = true;
            this.korv = element;
        },
        syncClipcards() {
            let self = this;
            this.loadingText = "Synkar produkter, detta tar en stund...";
            this.loading = true;
            axios
                .post(
                    self.authStore.api + "/sales/settings/sync-clipcards",
                    {},
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response.data);
                    self.clipcards = response.data.clipcards;
                    self.clipcardLastSync = response.data.clipcards_last_sync;
                    self.loading = false;
                })
                .catch((error) => {
                    self.loading = false;
                    toast("Produkter kunde inte synkas", {
                        type: "error",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslyHTMLString: true,
                    });
                    console.log(error);
                });
        },
        addProduct(data) {
            console.log(data);
            console.log(this.korv);
            this.korv.products.push({
                name: data.name,
                clipcard: data.name,
                description: "",
                open: true,
            });
        },
        getTranslation(id) {
            if (this.currentTranslation === "false") {
                return;
            }

            if (
                this.translations[this.currentTranslation]?.translations[id] ===
                undefined
            ) {
                this.translations[this.currentTranslation].translations[id] =
                    "";
            }

            return this.translations[this.currentTranslation].translations[id];
        },

        getTranslationTextarea(id) {
            if (this.currentTranslation === "false") {
                return;
            }

            if (
                this.translations[this.currentTranslation]?.translations[id] ===
                undefined
            ) {
                this.translations[this.currentTranslation].translations[id] =
                    "";
            }

            return this.translations[this.currentTranslation].translations[id];
        },

        updateTranslation(id, event) {
            this.translations[this.currentTranslation].translations[id] =
                event.target.value;
        },
        updateTranslationTextarea(id, editor) {
            this.translations[this.currentTranslation].translations[id] =
                editor.value.__quill.root.innerHTML;
        },
        changeTab(tab) {
            this.currentTab = tab;
            window.scrollTo(0, 0);
        },
        createUniqeId() {
            return uuid();
        },
        removeItem(mainIndex, index) {
            this.mainCategories[mainIndex].categories.splice(index, 1);
        },
        save() {
            this.loading = true;
            let self = this;
            let SalesSettings = {
                sms: this.sms,
                knowledgeBank: this.knowledgeBank,
                productCategories: this.productCategories,
                defaultCategories: this.defaultCategories,
                campaigns: this.campaigns,
                recommended: this.recommended,
                recommendedTexts: this.recommendedTexts,
            };

            axios
                .post(
                    self.authStore.api + "/sales/settings/update",
                    {
                        SalesSettings: SalesSettings,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    self.loading = false;
                    toast("Inställningarna sparade!", {
                        type: "success",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslyHTMLString: true,
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style>
.settings-holders {
    padding: 200px 20px 20px 20px;
    background-color: #fff;
    margin: 0;
    min-height: 100%;

    &.have-top-header {
        padding-top: 270px;
    }
}

.category-header {
    .board-info-button {
        top: 0;
    }
}

.handle-product {
    .board-info-button {
        top: 0;
    }
}

.list-item-header {
    .board-info-button {
        top: 0;
    }    
}

.holder-settings {
    display: flex;
    width: calc(100% - 20px);
    max-width: 1200px;
    margin: 0 auto;
    flex-direction: column;
    margin-bottom: 60px;
    margin-top: 40px;
    justify-content: flex-start;
    align-items: flex-start;

    h2 {
        margin-bottom: 10px;
    }
}

.holder-settings-small {
    max-width: 850px;
}


.settings-header {
    display: flex;
    width: calc(100% - 20px);
    max-width: 1200px;
    margin: 0 auto;
    flex-direction: column;
}

table {
    width: 900px;
    margin-bottom: 32px;

    td {
        vertical-align: middle;
    }

    > td {
        padding-right: 20px;
    }

    .arrow {
        margin: 0 16px;
    }
}

.table-row {
    padding: 0 30px;
    transition: all 0.1s ease;
    margin-left: -30px;

    flex-direction: column;
    margin-bottom: 30px;

    > div {
        margin-bottom: 6px;
    }

    &:hover {
        background-color: #f6f6f6;
        transition: all 0.1s ease;
    }

    @media (min-width: 900px) {
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 20px;

        > div {
            margin-bottom: 0;
        }
    }
}

td .input-setting {
    width: 300px;
}

.types {
    position: fixed;
    right: 0;
    top: 0;
    width: 400px;
    background-color: cadetblue;
    height: 100%;
}

.category {
    max-width: 1200px;
    width: 100%;
    margin-bottom: 30px;
}

.handle {
    cursor: move;
}

.list-group {
    margin-bottom: 30px;
}

.list-item {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: column;
    margin-bottom: 10px;
    width: calc(100% - 100px);
}

.list-item-open {
    margin-bottom: 10px;
}

.list-item-header {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0;
    border-radius: 6px 6px 0 0;
    background-color: #fff;
    color: #000;
    border: 1px solid #A1B1C8;

    input {
        font-family: "helvetica-regular", sans-serif;
        background-color: transparent;
        font-size: 12px;
        font-weight: 400;
        border: 0;
        color: #000;
        height: 38px;

        &:focus {
            border: 0;
            outline: 0;
        }
    }
}

.list-item-header-actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    padding-right: 20px;
    position: relative;
}

.list-item-content {
    padding: 0;
    width: 100%;
    border: 1px solid #ccd5e0;
    border-top: 0;
    border-radius: 0 0 6px 6px;
    overflow: hidden;

    &.with-padding {
        padding: 20px;
    }

    > label {
        margin-bottom: 10px;
        display: block;
    }
}

.more-settings {
    width: 100%;
    background-color: papayawhip;
    margin-left: 50px;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.action-list {
    width: 100%;
}

.input[type="text"].input-setting {
    width: 100%;
    max-width: 630px;
    height: 50px;
    border: 1px solid rgba(161, 177, 200, 0.5);
    background-color: #fff;
    margin-bottom: 0;
    border-radius: 6px;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 300;
}

input[type="number"].input-setting-due-date {
    width: 80px;
}

input[type="text"].input-header {
    background-color: unset;
    border: unset;
    width: unset;
    color: #fff;
    margin: 0;
    padding: 0;
    font-family: "hansen-grotesque-bold", sans-serif;
    font-size: 17px;
    font-weight: 700;
    line-height: 33px;
    height: 40px;

    &:active,
    &:focus {
        outline: none;
        border: 0;
    }
}
.textarea {
    max-width: 100%;
    width: 630px;
    height: 120px;
    margin-bottom: 40px;
    padding: 20px;
    border: 1px solid #ccd5e0;
    background: #fff;
    border-radius: 6px;
    resize: none;
    font-family: "helvetica-regular", sans-serif;
    font-size: 16px;
    font-weight: 300;

    &:focus {
        border: 1px solid rgba(161, 177, 200, 1);
        outline: 0;
    }

    &:active {
        border: 1px solid rgba(161, 177, 200, 1);
        outline: 0;
    }
}

.pointer {
    cursor: pointer;
}

.settings-header {
    height: 100px;
}

.settings-save {
    position: fixed;
    right: 20px;
    bottom: 20px;
}

.category-header {
    background: #000;
    display: flex;
    padding: 0 10px;
    align-items: center;
    justify-content: flex-start;
    border-radius: 6px;
    margin-bottom: 20px;
    color: #fff;
    width: calc(100% - 50px);

    .handle {
        margin-right: 11px;
        margin-left: 6px;
    }
}

.category-header-no-handle {

    width: 100%;

    input {
        margin-left: 10px !important;
    }
}

.board-settings {
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 32px;
}

.board-settings-open {
    transform: rotate(180deg);
    transition: all 0.3s ease;
}

.input-header-buttons {
    display: flex;
    align-items: center;
    color: #fff;
    margin-left: auto;
    position: relative;
}

.actions-holder {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;
}

.holder-settings {
    select {
        width: 345px;
    }
}

.QuillEditorHolder {
    width: 100%;
    height: 300px;
    margin-bottom: 80px;
}

.action-category {
    margin-top: 10px;

    strong {
        margin-bottom: 6px;
        display: block;
    }
}

.settings-tabs {
    position: fixed;
    width: 100%;
    top: 90px;
    background-color: #fff;
    z-index: 10;
    padding-top: 6px;
}

.setting-tab {
    padding-bottom: 100px;
}

.translation-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 60px;
}

.translation-orignal-text {
    width: calc(50% - 20px);
    display: flex;
    flex-direction: column;
}

.translation-translated-text {
    width: calc(50% - 20px);
    display: flex;
    flex-direction: column;
}

.w-full {
    width: 100%;
}

.translation-editor-holder {
    width: 100%;
    height: 100%;
    margin-bottom: 80px;
}

.sms-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    label {
        margin-bottom: 0;
    }
}

.sms-delete-button {
    margin-left: auto;
}

.letter-count {
    top: -30px;
    position: relative;
    font-size: 13px;
}

.clipcard-settings-buttons {
    margin-top: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    margin-top: 70px;

    span {
        font-size: 10px;
        text-align: center;
        width: 100%;
        display: block;
        margin-top: 10px;
        margin-left: 10px;
    }

    .button {
        margin-left: 30px;
    }
}

.recommended-line {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;

    input {
        height: 40px;
        width: calc(40% - 40px);
        margin-right: 30px;
        background-color: #fff;
    }

    select {
        height: 40px;
        width: calc(60% - 50px);
        background-position-y: 7px;
    }

    .board-add-button {
        margin-right: 0;
        margin-left: 10px;
    }

    .QuillEditorHolder {
        margin-top: 20px;
    }
}

.recommended-zip-holder {
    width: 100%;
    margin-bottom: 40px;
}

.board-delete-button {
    position: absolute;
    top: -4px;
    right: -60px;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    font-size: 20px;
    color: #0033FF;
    border: 1px solid #a1b1c8;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}


.list-item-header-actions {
    .board-delete-button {
        right: -50px;
    }
}

.board-add-button {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    font-size: 20px;
    color: #0033FF;
    border: 1px solid #a1b1c8;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 50px;
}

.settings-line {
    width: 100%;
    background-color: #A1B1C8;
    height: 1px;
    margin: 40px 0 30px 0;
}

.settings-label {
    font-size: 12px;
    font-family: 'hansen-grotesque-bold';
    font-weight: 700;
    text-transform: unset;
    color: #000;
    margin-bottom: 10px;
}

.settings-input {
    background-color: #fff !important;
    max-width: 100% !important;
}

.have-top-header {
    top: 180px
}

.settings-header-top {
    position: fixed;
    width: 100%;
    top: 90px;
    background-color: #F2F2F2;
    z-index: 10;
    height: 90px;

    > div {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
    }
}

</style>